export const FACEBOOK_URL = "https://www.facebook.com/bettyapp.hn"
export const INSTAGRAM_URL = "https://www.instagram.com/bettyapp.hn/?hl=es"
export const WHATSAPP_CHAT = "https://wa.me"
export const MESSENGER_CHAT = "https://fb.com/book/bettyapp.hn/"
export const WAZE_URL = "https://www.waze.com"

export const IMAGE_PATTERN = /^image-([a-f\d]+)-(\d+x\d+)-(\w+)$/
export const FACEBOOK_APP_ID = 1449413592081586

export const CAMPAING_END_DATE = new Date(2020, 6, 27, 13, 0, 0)
